<script setup lang="ts">
import { sleep, useHttpClient, useLoadingState } from "@/vf"
import { ref } from "vue"

const props = defineProps<{
    accountId: string
}>()

const emit = defineEmits<(e: "done") => void>()
const http = useHttpClient()

const loading = useLoadingState()
const success = ref(false)

function confirm() {
    loading.while(async () => {
        await http.post(`/person-action/${props.accountId}/delete-member`)
        success.value = true

        await sleep(2000)
        emit("done")
    })
}
</script>
<template>
    <div v-if="success">
        {{ $t("@app:organization_member.person_actions_wizard.actions.DeleteMember.success") }}
    </div>
    <div v-else>
        <p>
            {{ $t("@app:organization_member.person_actions_wizard.actions.DeleteMember.confirmation") }}
        </p>

        <button class="btn btn-primary mt-3" type="button" :disabled="loading.state" @click="confirm">
            {{ $t("@app:organization_member.person_actions_wizard.actions.DeleteMember.confirm") }}
        </button>
        <i class="fa fa-fw fa-spinner fa-spin" v-if="loading.state"></i>
    </div>
</template>
